// src/components/ui/badge.jsx
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-bold tracking-wide transition-colors",
  {
    variants: {
      variant: {
        default:     "bg-primary-500 text-base-50",
        destructive: "bg-primary-500 text-base-50",
        gold:        "bg-yellow-500 text-base-50",
        outline:     "bg-white text-current border border-current",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export function Badge({ className, variant, ...props }) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}